module.exports = __webpack_public_path__ + "img/search_doc_icon.fbe4d02b.svg";